"use client";
import { IBlocks } from "@/types";
import BlockToggle from "../toggle";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function KickOptions({ block, blockUpdate, update }: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [name, setName] = React.useState(block.name);
    const [url, setUrl] = React.useState(block.url);
    return (
        <div className="flex w-full flex-col gap-3">
            <div className="flex w-full flex-col gap-3">
                <CardSetting title="General" noBorder>
                    <div className="flex w-full flex-col gap-3">
                        <Input
                            label="Title"
                            variant="card"
                            className="w-full"
                            required
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                blockUpdate({
                                    ...block,
                                    name: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (oldBlock.name != e.target.value) {
                                    update({
                                        ...block,
                                        name: e.target.value,
                                    });
                                    setOldBlock({
                                        ...oldBlock,
                                        name: e.target.value,
                                    });
                                }
                            }}
                        />
                        <Input
                            label="Kick Username"
                            variant="card"
                            className="w-full"
                            type="text"
                            value={url}
                            onChange={(e) => {
                                setUrl(e.target.value);
                                blockUpdate({
                                    ...block,
                                    url: e.target.value,
                                });
                            }}
                            onBlur={(e) => {
                                if (oldBlock.url != e.target.value) {
                                    update({
                                        ...block,
                                        url: e.target.value,
                                    });
                                    setOldBlock({
                                        ...oldBlock,
                                        url: e.target.value,
                                    });
                                }
                            }}
                        />
                        <div className="flex items-center justify-between gap-4">
                            <Label>Hide when offline?</Label>
                            <Switch
                                checked={block.options?.hide_offline}
                                onCheckedChange={(value) => {
                                    update({
                                        ...block,
                                        options: {
                                            ...block.options,
                                            hide_offline: value,
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>
                </CardSetting>
            </div>
        </div>
    );
}

export function BlockOptions({ block, blockUpdate, update }: Props) {
    return (
        <BlockToggle block={block} blockUpdate={blockUpdate} update={update} />
    );
}
